module.exports = __webpack_public_path__ + "img/croatia.ea91fcf5.svg";